var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSend2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1411 3.46004L7.11109 6.46004C1.04109 8.49004 1.04109 11.8 7.11109 13.82L9.79109 14.71L10.6811 17.39C12.7011 23.46 16.0211 23.46 18.0411 17.39L21.0511 8.37004C22.3911 4.32004 20.1911 2.11004 16.1411 3.46004ZM16.4611 8.84004L12.6611 12.66C12.5111 12.81 12.3211 12.88 12.1311 12.88C11.9411 12.88 11.7511 12.81 11.6011 12.66C11.3111 12.37 11.3111 11.89 11.6011 11.6L15.4011 7.78004C15.6911 7.49004 16.1711 7.49004 16.4611 7.78004C16.7511 8.07004 16.7511 8.55004 16.4611 8.84004Z",
    fill: "#2E1834"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend2);
export default __webpack_public_path__ + "static/media/send-2.c9dbb67ac41641ef218fc4b9ed29cf46.svg";
export { ForwardRef as ReactComponent };